var e={categoriesLabel:"Useful link categories",label:"Word cloud"};export{e as wordCloudTranslations};
